import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/first-order': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M12.9 229.2c0.1-0.1 0.2-0.3 0.3-0.4 0 0.1 0 0.3-0.1 0.4h-0.2zM224 96.6c7.4 0 14.6 0.5 21.7 1.7l-4 67.7 22.3-64.3c14.3 3.8 27.7 9.5 40 16.9l-29.4 61.1 45.1-50.9c11.5 8.9 21.7 19.2 30.6 30.9l-50.6 45.4 60.9-29.7c7.5 12.3 12.9 26 16.6 40.3l-64 22.3 67.7-4c1.1 7.1 1.4 14.6 1.4 22s-0.3 14.6-1.4 21.7l-67.4-4 64 22.3c-3.7 14.6-9.5 28-16.6 40.3l-61.1-29.4 50.6 45.1c-8.6 11.8-18.9 22-30.6 30.9l-44.9-50.9 29.4 61.3c-12.3 7.5-25.7 12.9-40 16.9l-22.6-65.1 4 68.6c-7.1 1.1-14.3 1.7-21.7 1.7-7.1 0-14.6-0.6-21.7-1.7l4-68-22.3 64.6c-14.3-3.8-27.7-9.5-40-16.9l29.5-61.4-44.9 50.9c-11.8-8.6-22-19.2-30.9-30.9l50.9-45.1-61.1 29.7c-7.2-12.6-12.9-26-16.6-40.3l64-22.6-67.7 4c-0.8-7.1-1.4-14.3-1.4-21.7s0.5-14.9 1.4-22l68 4-64.3-22.6c3.7-14.3 9.5-27.7 16.6-40l61.1 29.7-50.6-45.4c8.9-11.8 19.2-22 30.6-30.9l45.1 50.9-29.4-61.4c12.3-7.2 25.7-12.9 40-16.6l22 64-3.7-67.4c6.8-1.1 14.3-1.7 21.4-1.7zM443.4 128v256l-219.4 128-219.4-128v-256l219.4-128zM426.3 138.3l-202.3-117.4-202.3 117.4v235.1l202.3 117.7 202.3-117.7v-235.1zM224 37.1l187.7 109.4v218.9l-187.7 109.5-187.7-109.5v-218.8zM224 88c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/first-order.js
// module id = 829
// module chunks = 0